import {
    SEARCH_USERS,
    SET_LOADING,
    CLEAR_USERS,
    GET_USER,
    GET_REPOS
} from './../types';

export default (state, action) => {
    switch(action.type) {
        case SEARCH_USERS:
            return {
                // * makes a copy of the state, followed by any updates (additions)
                ...state,
                users: action.payload,
                loading: false
            };
        case GET_USER:
            return {
                // * makes a copy of the state, followed by any updates (additions)
                ...state,
                user: action.payload,
                loading: false
            };
        case CLEAR_USERS:
            return {
                ...state, 
                users: [],
                loading: false
            };
        case SET_LOADING:
            return {
                ...state, 
                loading: true
            };
        case GET_REPOS:
            return {
                // * makes a copy of the state, followed by any updates (additions)
                ...state,
                repos: action.payload,
                loading: false
            };
        default: 
            return state
    }
}